import { useEffect, useState } from "react";
import Check from '../../../../../assets/iconos/checkg.png';
import DialogModal from "../../../../Modals/dialogModal";

var index = 0;
const QuestionFrame = (props) => {

    const [actual, setActual] = useState(props.question[0]);
    const [showModal, setShowModal] = useState(false)

    const handlerAwnser = async (e, isCorrect) => {
        if(isCorrect == true){
            index++;
            if(props.question.length > index){
                setActual(props.question[index]);
            }else{
                setActual(null);
                
                await props.setActivityScore({score:"Finalizada", id:props.idActivity});                
                props.setNext(true)
            }
        }else{
            setShowModal(true)
        }
    }

    useEffect(() => {
        index = 0;
    }, []);

    return(
        <div>
            <DialogModal showModal={showModal} setShowModal={setShowModal}>
                <h3>Intenta nuevamente</h3>
            </DialogModal>
            <div className="canvaFrame downloadFrame">
                {
                    actual != null ?
                    <>
                    <h1 className="blackQuestionTittle">{actual.question}</h1>
                    <h5>{actual.help}</h5>
                    {
                        actual.ansers.map((item, index) => {
                            return(
                                <button key={index} className="green-btn setpointer awnser-btn" onClick={e => handlerAwnser(e, item.isCorrect)}>{item.anser}</button>
                                );
                            })
                    }
                    </>
                    :
                    <img src={Check} className="checkAct"/>
                }
                
            </div>
        </div>
    );
}

export default QuestionFrame;